<template>
  <form @keyup.enter="save">
    <div>
      <!--<div class="control is-horizontal columns">
      <div class="control-label label-create column is-3">
        <label class="label">First Name</label>
      </div>
      <div class="control is-grouped column is-9">
        <p class="control is-expanded">
          <input v-validate="'required|max:255'" :class="{'is-danger': errors.has('firstname') }" name="firstname" v-model="body.firstname" class="input" type="text" placeholder="Enter first name">
          <span v-show="errors.has('firstname')" class="help is-danger">{{ errors.first('firstname') }}</span>
        </p>
      </div>
    </div>

    <div class="control is-horizontal columns">
      <div class="control-label label-create column is-3">
        <label class="label">Last Name</label>
      </div>
      <div class="control is-grouped column is-9">
        <p class="control is-expanded">
          <input v-validate="'required|max:255'" :class="{'is-danger': errors.has('lastname') }" name="lastname" v-model="body.lastname" class="input" type="text" placeholder="Enter last name">
          <span v-show="errors.has('lastname')" class="help is-danger">{{ errors.first('lastname') }}</span>
        </p>
      </div>
    </div>-->
      <div class="control is-horizontal columns">
        <div class="control-label label-create column is-3">
          <label class="label field-required">Email</label>
        </div>
        <div class="control is-grouped column is-9">
          <p class="control is-expanded">
            <input
              v-validate="'required|max:255|email'"
              :class="{'is-danger': errors.has('email') }"
              name="email"
              v-model="body.email"
              class="input"
              type="text"
              placeholder="Enter email"
              :disabled="disabled"
            >
            <span
              v-show="errors.has('email')"
              class="help is-danger"
            >{{ errors.first('email') }}</span>
          </p>
        </div>
      </div>

      <div class="control is-horizontal columns">
        <div class="control-label label-create column is-3">
          <label
            class="label "
            :class="{'field-required': !isEdit }"
          >Password</label>
        </div>
        <div class="control is-grouped column is-9">
          <p class="control is-expanded">
            <input
              v-validate="validate"
              :class="{'is-danger': errors.has('password') }"
              name="password"
              v-model="body.password"
              class="input"
              type="text"
              placeholder="Enter password"
            >
            <span
              v-show="errors.has('password')"
              class="help is-danger"
            >{{ errors.first('password') }}</span>
          </p>
        </div>
      </div>
      <div class="control is-horizontal columns">
        <div class="control-label label-create column is-3">
          <label class="label field-required">Role</label>
        </div>
        <div class="control is-grouped column is-9">
          <!-- v-if="profile && profile.available_roles" -->
          <p class="control is-expanded">
            <v-select
              :disabled="data.id && data.id === 1"
              label="name"
              multiple
              v-model="body.roles"
              :options="roles"
              @input="onChangeRole"
              :class="{'is-danger': roleRequired }"
            ></v-select>
            <span
              v-show="roleRequired"
              class="help is-danger"
            >The role field is required.</span>
          </p>
        </div>
      </div>

      <div class="control is-horizontal columns">
        <div class="control-label label-create column is-3">
          <label class="label"></label>
        </div>
        <div class="control column is-9">
          <save-button
            :loading="isSaving"
            @click="save"
          />
          <a
            @click="cancel"
            class="button is-link"
          >Cancel</a>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import mixins from 'components/mixin';
  import { role } from 'api';
  import { mapGetters } from 'vuex'
  export default {
    mixins: [mixins],
    props: {
      data: {
        type: Object,
        default () {
          return {}
        }
      },
      isSaving: Boolean,
      isEdit: Boolean,
      disabled: {
        default: false,
        type: Boolean
      },
      validate: {
        default: 'required|max:16|min:6',
        type: String
      }
    },
    computed: {
      ...mapGetters(['profile'])
    },
    data () {
      return {
        body: {
          email: this.data.username ? this.data.username : '',
          roles: this.data.roles ? this.data.roles : null,
          password: undefined
        },
        roles: [],
        roleRequired: false
      }
    },
    methods: {
      getRoles () {
        role.get().then(res => {
          if (res.data.success) {
            res.data.data.map(e => {
              return this.roles.push(e.name);
            })
            this.roles = [...res.data.data];
          }
        }).catch(err => {
          if (err.response) {
            me.openNotificationWithType('danger', {
              'title': 'Failed!',
              'message': err.response.data.error.message
            });
          }
        });
      },
      onChangeRole () {
        this.roleRequired = this.body.roles <= 0;
      },
      cancel () {
        this.$emit('cancel');
      },
      save () {
        this.$validator.validateAll().then((result) => {
          if (this.body.roles === null) {
            this.roleRequired = true;
          }
          if (result && !this.roleRequired) {
            let data = Object.assign({}, this.body);
            let arr = [];
            this.body.roles.forEach(el => {
              arr.push(el.name);
            });
            data.roles = [...arr];
            if (this.body.password === '') {
              data.password = undefined;
            }
            if (this.data.id === 1) {
              data.roles = undefined;
            }
            this.$emit('save', data);
          }
        })
      }
    },
    mounted () {
      this.getRoles();
    },
    created () {
    },
  }
</script>

<style scoped>
</style>
